import React, {useState} from "react";
import {Card} from "../../../../../components/card/card.jsx";
import {Modal} from "../../../../../components/modal/modal.jsx";
import InputForm from "../../../../../components/input/input-form.jsx";
import InputDatetime from "../../../../../components/input/input-datetime.jsx";
import Button from "../../../../../components/button/button.jsx";
import {FaPen, FaPlus, FaTrash} from "react-icons/fa";
import {displacementSummary, emptyLocation} from "../utils/dispatch-form-utils.js";
import RegisteredLocation from "../../../../../components/registered-location/registered-location.jsx";
import projectUtils from "../../../../../utils/project-utils.js";

const DispatchDisplacements = ({rows, setRows, kmControl, showAdd, onAdd, suggestedCity = ""}) => {
    const [editing, setEditing] = useState(null);
    const [address, setAddress] = useState(emptyLocation());
    const [isEditable, setIsEditable] = useState(false);

    const updateRow = (tempId, partial) =>
        setRows(prev => prev.map(row => row.tempId === tempId ? {...row, ...partial} : row));

    const removeRow = (tempId) => setRows(prev => prev.filter(row => row.tempId !== tempId));

    const openEdit = (row, index) => {
        const base = row.location ?? emptyLocation();
        setAddress(base.city ? base : {...base, city: suggestedCity});
        setEditing(row.tempId);
        setIsEditable(index > 0)
    };

    const saveAddress = () => {
        if (editing) updateRow(editing, {location: address});
        setEditing(null);
    };

    return (
        <Card>
            <Card.Header className="flex items-center gap-2">
                <Card.Title>Deslocamentos</Card.Title>
                {showAdd &&
                    <Button className="h-6! w-6.5! p-0!" title="Adicionar deslocamento" onClick={onAdd}><FaPlus/></Button>
                }
            </Card.Header>
            <Card.Body>
                <div className="rounded-lg border border-[#D2D3D5] font-[Roboto,sans-serif] text-[#2E3742]">
                    <table className="w-full text-sm border-collapse">
                        <thead>
                            <tr className="bg-[#efefef] text-left border-b border-[#D2D3D5]">
                                <th className="px-2 h-10 font-bold">Destino</th>
                                <th className="px-2 h-10 font-bold w-[18%]">Horário (partida)</th>
                                <th className="px-2 h-10 font-bold w-[11%]">Km (partida)</th>
                                <th className="px-2 h-10 font-bold w-[18%]">Horário (chegada)</th>
                                <th className="px-2 h-10 font-bold w-[11%]">Km (chegada)</th>
                                <th className="px-2 h-10 w-[50px]"/>
                            </tr>
                        </thead>
                        <tbody>
                            {rows.map((row, index) => {
                                const isLast = index === rows.length - 1;
                                return (
                                    <tr
                                        key={row.tempId}
                                        className={["align-top", isLast ? "" : "border-b border-[#D2D3D5]"].join(" ")}
                                    >
                                        <td className="p-2">
                                            <div className="flex items-center gap-2">
                                                <InputForm
                                                    classNameWrapper="flex-1"
                                                    id={`destinyDescr_${row.tempId}`}
                                                    label=""
                                                    value={displacementSummary(row.location)}
                                                    readOnly
                                                />
                                                <Button title="Editar destino" onClick={() => openEdit(row, index)}><FaPen/></Button>
                                            </div>
                                        </td>
                                        <td className="p-2">
                                            <InputDatetime
                                                id={`goingDate_${row.tempId}`}
                                                label=""
                                                dateFormat="LL"
                                                returnDateObj={false}
                                                selected={row.goingDate}
                                                onChange={(value) => updateRow(row.tempId, {goingDate: value ?? ""})}
                                            />
                                        </td>
                                        <td className="p-2">
                                            <InputForm
                                                id={`goingMileage_${row.tempId}`}
                                                label=""
                                                integerOnly
                                                type="number"
                                                value={row.goingMileage ?? ""}
                                                disabled={!kmControl}
                                                onChange={({target}) => updateRow(row.tempId, {goingMileage: target.value})}
                                            />
                                        </td>
                                        <td className="p-2">
                                            <InputDatetime
                                                id={`arrivalDate_${row.tempId}`}
                                                label=""
                                                dateFormat="LL"
                                                returnDateObj={false}
                                                selected={row.arrivalDate}
                                                onChange={(value) => updateRow(row.tempId, {arrivalDate: value ?? ""})}
                                            />
                                        </td>
                                        <td className="p-2">
                                            <InputForm
                                                id={`arrivalMileage_${row.tempId}`}
                                                label=""
                                                integerOnly
                                                type="number"
                                                value={row.arrivalMileage ?? ""}
                                                disabled={!kmControl}
                                                onChange={({target}) => updateRow(row.tempId, {arrivalMileage: target.value})}
                                            />
                                        </td>
                                        <td className="p-2 text-center">
                                            {index > 0 && !row.id &&
                                                <Button type="button" target="danger" title="Remover" onClick={() => removeRow(row.tempId)}><FaTrash/></Button>
                                            }
                                        </td>
                                    </tr>
                                );
                            })}
                            {!rows.length &&
                                <tr><td colSpan={6} className="px-2 h-7.5 text-center content-center">Nenhum deslocamento.</td></tr>
                            }
                        </tbody>
                    </table>
                </div>
            </Card.Body>

            <Modal open={!!editing} setOpen={(value) => { if (!value) setEditing(null); }} title="Destino" className="w-10/12">
                <Modal.Body className="max-h-[calc(100vh-180px)] overflow-auto">
                    <RegisteredLocation
                        showTitle={false}
                        data={address}
                        setData={setAddress}
                        storePlaceName
                        coordinatesRequired={false}
                        disabled={!isEditable}
                    />
                </Modal.Body>
                <Modal.Footer>
                    <Button onClick={saveAddress} disabled={!isEditable} actionFeedbackType='save'>Salvar</Button>
                </Modal.Footer>
            </Modal>
        </Card>
    );
};

export default DispatchDisplacements;